import { useEffect, useState, useCallback } from "react";
import { PhoneOutgoing, PhoneIncoming, MessagesSquare, Layers, BadgeCheck, CalendarClock, GraduationCap, Headset, LineChart, ShieldCheck, Target, Users, Wallet, Smile, Timer, ClipboardList, BookOpen, Megaphone, Activity, Flag, Star, Briefcase, Globe, Database } from "lucide-react";
import { useTenant } from "@/context/TenantContext";
import api from "@/lib/api";

export const ICONS = { PhoneOutgoing, PhoneIncoming, MessagesSquare, Layers, BadgeCheck, CalendarClock, GraduationCap, Headset, LineChart, ShieldCheck, Target, Users, Wallet, Smile, Timer, ClipboardList, BookOpen, Megaphone, Activity, Flag, Star, Briefcase, Globe, Database };
export const iconOf = (name) => ICONS[name] || Layers;
export const BESPOKE = new Set(["outbound-sales", "inbound-voice", "inbound-chat", "adherence"]);

let cache = { key: null, data: null };
const listeners = new Set();

export const invalidateModules = () => { cache = { key: null, data: null }; listeners.forEach((fn) => fn()); };

export const useModules = () => {
  const { tenantId } = useTenant() || {};
  const key = tenantId || "";
  const [modules, setModules] = useState(cache.key === key ? cache.data : null);

  const load = useCallback(() => {
    api.get(`/modules?tenant_id=${key}`).then((r) => { cache = { key, data: r.data }; setModules(r.data); }).catch(() => setModules([]));
  }, [key]);

  useEffect(() => {
    if (cache.key === key && cache.data) setModules(cache.data); else load();
    listeners.add(load);
    return () => listeners.delete(load);
  }, [key, load]);

  return { modules, allowed: (modules || []).filter((m) => m.allowed), reload: load };
};
